<template>
  <div class="slider">
    <div @click="onSex('male')">
      男
    </div>
    <div @click="onSex('female')">
      女
    </div>
    <span
      :class="{
        'float-label': true,
        'fe-male': value === 'male',
        'male-fe': value === 'female',
      }"
    >
      {{ value === 'male' ? '男' : '女' }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'Slider',
  props: {
    // 滑块的值
    value: {
      type: String,
      default: () => 'male',
    },
  },
  methods: {
    /**
     * 滑块点击事件
     *
     * @param {string} value 被选择的值
     */
    onSex(value) {
      this.$emit('update:value', value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.slider {
  position: relative;
  display: flex;
  align-items: center;
  width: rem(156);
  height: rem(26);
  background: #efefef;
  border-radius: 4px;
  .float-label {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div {
    width: 50%;
    height: 100%;
    line-height: rem(26);
  }
  span {
    position: absolute;
    display: inline-block;
    width: 50%;
    height: rem(22);
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.19);
  }
}
.fe-male {
  animation: toleft 0.2s forwards;
}
.male-fe {
  animation: toright 0.2s forwards;
}
@keyframes toright {
  0% {
    right: 50%;
  }
  20% {
    right: 40%;
  }
  40% {
    right: 30%;
  }
  60% {
    right: 20%;
  }
  80% {
    right: 10%;
  }
  100% {
    right: 2%;
  }
}
@keyframes toleft {
  0% {
    left: 50%;
  }
  20% {
    left: 40%;
  }
  40% {
    left: 30%;
  }
  60% {
    left: 20%;
  }
  80% {
    left: 10%;
  }
  100% {
    left: 2%;
  }
}
</style>
